/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extra_Session_Setting_TitleInputs */

const fr_extra_session_setting_title = /** @type {(inputs: Extra_Session_Setting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances supplémentaires`)
};

/**

* @param {Extra_Session_Setting_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const extra_session_setting_title = /** @type {((inputs?: Extra_Session_Setting_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extra_Session_Setting_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_extra_session_setting_title(inputs)
});